import React, { useState } from 'react'
import { Dropdown, Menu, Slider } from 'antd'
import Select from 'react-select'
import { Link, Route, Switch } from 'react-router-dom'
import moment from 'moment'

import { AiOutlineDown, AiOutlineReload } from 'react-icons/ai'

import { stringifyDate, useListData } from '../../modules'

import Receive from '../../components/reusable/receive'
import Patient from '../../components/reusable/patient'

import OrderItems from '../../components/drawers/orderItems'
import DateRangePicker from '../../components/reusable/rangePicker'

const Coding = ({ department }) => {  
    const [status, setStatus]  = useState()
    const [gender, setGender] = useState()
    const [under, setUnder] = useState(150)
    const [over, setOver] = useState(0)
    const [ranges, setRanges] = useState([moment().startOf('day'), moment().endOf('day')])

    const [
        { loading, error, fetch }, 
        { list: coding = [] }, 
        { navigate, Paginate, page = 1, limit = 10 }
    ] = useListData('coding', ranges ? { 
        department, 
        string: '', 
        // under,
        // over,
        gender: gender?.value,
        reattendance: status ? status?.label === 'Reattendance' : undefined,
        from: ranges[0]?._d ?? null, 
        to: ranges[1]?._d ?? null,
    } : { department, /*under, over,*/ gender: gender?.value, string: '', reattendance: status ? status?.label === 'Reattendance' : undefined }, { notify: true, manual: false })

    const refresh = () => {
        navigate(1)
        fetch()
    }

    const selectRange = range => {
        setRanges(range)
        refresh()
    }

    const changeStatus = stat => {
        setStatus(stat)
        refresh()
    }

    const selectGender = val => {
        setGender(val === 'All' ? undefined : val)
        refresh()
    }

    const setAgeRanges = range => {
        if (range[0] !== 0)
            setOver(range[0])

        if (range[1] !== 150)
            setUnder(range[1])

        refresh()
    }

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full mx-auto">
            <div className="sm:flex sm:justify-between sm:items-center mb-8">
                <ul className="flex flex-wrap justify-center sm:justify-start mb-8 sm:mb-0 -space-x-3 -ml-px" />
                <div className="grid grid-flow-col sm:auto-cols-max justify-between gap-2 w-full">
                    <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2">
                        <div class="w-100">
                            <Slider onAfterChange={ setAgeRanges } max={ 130 } tooltip={{ open: true }} range defaultValue={[0,150]}/>
                            <div className="flex w-64">
                                <span className="ml-2 mr-3 self-center">Select Age Ranges</span>
                            </div>
                        </div>
                        <Select
                            defaultValue="All"
                            style={{ width: 120 }}
                            onChange={ val => selectGender(val) }
                            options={[
                                { label: 'All', value: 'All' },
                                { label: 'Male', value: 'Male' },
                                { label: 'Female', value: 'Female' }
                            ]} />
                    </div>
                    <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2">'
                        <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2">
                            <DateRangePicker selectRange={selectRange} ranges={ ranges } />
                        </div>
                    </div>                    
                </div>
            </div>
            <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200">
                <header className="flex justify-between items-center px-5 py-4 border-b border-gray-100">
                    <h2 className="font-semibold text-gray-800">{ department } Diagnoses</h2>
                    <span className="flex items-center justify-between">
                        <Select
                            isClearable
                            value={status}
                            onChange={changeStatus}
                            styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                            options={ ['New Visit', 'Reattendance'].map(stat => ({ label: stat, value: stat }))}
                            placeholder="Select Status" />
                        <button onClick={refresh} className="btn mx-2 py-2.5 hisani-btn-green-light text-white">
                            <AiOutlineReload style={{ color: "white" }} />
                        </button>
                        <Link to={ `/app/records/diagnoses/${ department.toLowerCase() }/new` }>
                            <button className="btn hisani-btn-green-light text-white">
                                <svg className="w-4 h-4 fill-current opacity-50 flex-shrink-0" viewBox="0 0 16 16">
                                    <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                                </svg>
                                <span className="hidden xs:block ml-2">New Coding</span>
                            </button>
                        </Link>
                    </span>
                </header>
                <div className="p-3">

                    {/* Table */}
                    <div className="overflow-x-auto">
                        <Receive
                            error={error}
                            loading={loading}
                            progress>
                            {
                                coding.length > 0 ?
                                    <table className="table-auto w-full">
                                        {/* Table header */}
                                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                            <tr>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">No</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Patient</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Visit Details</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Diagnosis</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Recorded By</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center"></div>
                                                </th>
                                            </tr>
                                        </thead>
                                        {/* Table body */}
                                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                                            {/* Row */}
                                            {
                                                coding.map((cd, key) =>
                                                    <tr>
                                                        <td className="p-2">
                                                            <div className="text-center">{((page - 1) * limit) + key + 1}.</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <Patient patient={ cd?.patient } />
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="">{ cd?.item?.name }</div>
                                                            <p className={ `text-left text-xs italic mb-0 ${ cd?.reattendance ? 'text-yellow-500' : 'text-green-500' }` }>{ cd?.reattendance ? 'Reattendance' : 'New Visit' }</p>
                                                            {
                                                                cd?.itemDate &&
                                                                <p className="text-gray-500 text-xs italic mb-0">Visit date: { stringifyDate(cd.itemDate) }</p>
                                                            }
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-left">{ cd?.diagnosis } ({ cd?.diagnosisCode })</div>
                                                            <p className="text-gray-500 text-xs italic mb-0">{ cd?.classification }</p>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-left">{ cd?.recordedBy?.name }</div>
                                                        </td>
                                                        <td className="p-2 text-center">
                                                            <Dropdown
                                                                overlay={
                                                                    <Menu>
                                                                        <Link to={ `/app/records/diagnoses/${ department.toLowerCase() }/${cd?._id}` }>
                                                                            <Menu.Item>View</Menu.Item>
                                                                        </Link>
                                                                    </Menu>
                                                                }>
                                                                <a className="ant-dropdown-link flex items-center h-10" onClick={e => e.preventDefault()}><span className="mr-2">Actions</span> <AiOutlineDown /></a>
                                                            </Dropdown>
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                :
                                    <div className="w-full h-16 flex items-center justify-center">
                                        <p className="font-semibold text-base">Please click above to add a new coding</p>
                                    </div>
                            }
                        </Receive>
                        {Paginate}
                    </div>
                </div>
                <Switch>
                    <Route path={ `/app/records/diagnoses/${ department.toLowerCase() }/new` }>
                        <OrderItems department={ department } path={ `/app/records/diagnoses/${ department.toLowerCase() }` } />
                    </Route>
                </Switch>
            </div>
        </div>
    )
}

export default Coding
